export { default } from './StaticMap';
